import { PaginatorInterface } from '../../models/paginator.interface';

export interface PaginatorInterfaceState {
  paginator: PaginatorInterface;
}

export const initialPaginatorState: PaginatorInterfaceState = {
  paginator: null
};
